<template>
  <div class="home">
    <HeroSection :data="heroData" />
    <EditorialIntro :data="editorialData" />
    <BusinessMatrix :data="matrixData" @navigate="handleNavigate" />
    <Capabilities :data="capabilitiesData" />
    <FeaturedGifts :data="giftsData" />
    <DataCredibility :data="dataCredibilityData" />
  </div>
</template>

<script>
import HeroSection from "./components/HeroSection.vue";
import EditorialIntro from "./components/EditorialIntro.vue";
import BusinessMatrix from "./components/BusinessMatrix.vue";
import Capabilities from "./components/Capabilities.vue";
import FeaturedGifts from "./components/FeaturedGifts.vue";
import DataCredibility from "./components/DataCredibility.vue";

export default {
  name: "Home",
  components: {
    HeroSection,
    EditorialIntro,
    BusinessMatrix,
    Capabilities,
    FeaturedGifts,
    DataCredibility,
  },
  data() {
    return {
      heroData: {
        eyebrow: "GUANGDONG CULTURAL ASSET PORTAL",
        title: "从岭南风物出发<br/>连接文化资源与时代价值",
        copy: "粤文购依托广东省南方文化产权交易所官方平台，汇聚文化产权服务、艺术品交易、广东礼物与特色收藏内容，呈现兼具文化气韵与合作价值的岭南文化门户。",
        primaryText: "了解平台",
        primaryLink: "#",
        secondaryText: "浏览业务矩阵",
        secondaryLink: "#",
      },
      editorialData: {
        label: "OFFICIAL TRUST & PARTNERSHIP",
        title: "官方平台，汇聚多元文化服务资源",
        description:
          "依托广东省南方文化产权交易所官方平台，面向文化资源展示、合作对接与服务链接，并通过确权、溯源、鉴定与交割能力建立清晰可信的合作基础。",
        cards: [
          {
            icon: "icon-a-yinhangjinrongjigou",
            title: "官方平台",
            description:
              "依托广东省南方文化产权交易所官方平台，面向文化资源展示、合作对接与服务链接。",
            bgColor: "#FBF8F3",
            badgeBg: "#F2E7D3",
            badgeBorder: "#D8C6A2",
            dividerColor: "#DDD4C4",
          },
          {
            icon: "icon-shenjing",
            title: "合作共建",
            description:
              "联动版权、文化服务与专业机构资源，构建更完整的岭南文化服务生态。",
            bgColor: "#F3EEE5",
            badgeBg: "#E7D8C3",
            badgeBorder: "#D5BE98",
            dividerColor: "#D9CEBD",
          },
          {
            icon: "icon-anquan",
            title: "合规可信",
            description:
              "围绕确权、溯源、鉴定与交割等服务能力，建立清晰可感的合作信任基础。",
            bgColor: "#FBF8F3",
            badgeBg: "#F2E7D3",
            badgeBorder: "#D8C6A2",
            dividerColor: "#DDD4C4",
          },
        ],
      },
      matrixData: {
        label: "FOUR BUSINESS PILLARS",
        title: "四大业务板块，展开平台全景",
        description:
          "围绕文化资源流通、专业交易服务与岭南特色内容展示，粤文购构建兼具官方属性与文化温度的业务矩阵。",
        cards: [
          {
            title: "南方文化商城",
            description:
              "汇聚数字文化资源与特色内容，呈现官方平台的核心服务入口。",
            image: require("@/assets/images/homepage_matrix_southern_cultural_mall.png"),
            route: "CulturalMall",
          },
          {
            title: "艺术品交易平台",
            description:
              "提供鉴定、挂牌、交割等专业服务，满足更高标准的艺术品流通需求。",
            image: require("@/assets/images/homepage_matrix_art_trading_platform.png"),
            route: "ArtTrade",
          },
          {
            title: "广东礼物",
            description:
              "甄选非遗工艺、老字号与岭南特产，让地方文化以更亲近的方式被看见与带走。",
            image: require("@/assets/images/homepage_matrix_guangdong_gifts.png"),
            route: "Gift",
          },
          {
            title: "数遗光年",
            description:
              "年轻人的潮玩APP，构建了一个非常宏大且迷人的赛博朋克或未来国潮世界观。",
            image: require("@/assets/images/homepage_matrix_digital_heritage.png"),
            route: "Heritage",
          },
        ],
      },
      capabilitiesData: {
        label: "PLATFORM CAPABILITIES",
        title: "专业服务能力，支撑文化资源价值转化",
        cards: [
          {
            title: "合规交易体系",
            description:
              "依托规范服务流程与平台机制，为文化资源流通与合作对接提供稳健支撑。",
            image: require("@/assets/images/homepage_capability_compliance_trade.png"),
            bgColor: "#FBF8F3",
            borderColor: "#DDD4C4",
          },
          {
            title: "区块链确权与溯源",
            description:
              "通过确权、溯源与信息留存机制，提升文化资源流通的透明度与可信度。",
            image: require("@/assets/images/gifts_still_life_interior.png"),
            bgColor: "#E8EEF4",
            borderColor: "#D7E0EA",
          },
          {
            title: "专业鉴定与托管服务",
            description:
              "覆盖鉴定、仓储、交割与托管等环节，满足专业场景下的服务需求。",
            image: require("@/assets/images/homepage_capability_appraisal_storage.png"),
            bgColor: "#FBF8F3",
            borderColor: "#DDD4C4",
          },
        ],
      },
      giftsData: {
        label: "FEATURED CULTURAL CURATION",
        title: "重点业务聚焦：广东礼物",
        mainImage: require("@/assets/images/homepage_featured_gifts_main_visual.png"),
        lead: "让广东文化可带走、可体验、可传播",
        description:
          "广东礼物承担整站最强的文化情绪与内容表达，通过非遗工艺、老字号与岭南特产建立地方文化温度。",
        cards: [
          {
            title: "NO.01 / 非遗工艺\n广彩瓷器",
            description: "广州 · 国家级非遗，色彩斑斓，适合收藏与礼赠。",
          },
          {
            title: "NO.02 / 文房精品\n端砚",
            description:
              "肇庆 · 中国四大名砚之首，兼具文化象征与商务礼赠属性。",
          },
          {
            title: "NO.03 / 老字号\n陈李济陈皮",
            description: "广州 · 中华老字号，是岭南养生文化的代表性礼品。",
          },
        ],
      },
      dataCredibilityData: {
        label: "DATA CREDIBILITY",
        title: "用数据强化平台规模与可信度",
        bgImage: require("@/assets/images/homepage_data_credibility_bg.png"),
        metrics: [
          { value: "50亿+", label: "累计交易额" },
          { value: "100万+", label: "注册用户" },
          { value: "10000+", label: "上架藏品" },
          { value: "99.9%", label: "客户满意度" },
        ],
        trendLabel: "交易趋势 / TREND",
        trendDescription:
          "数据区以官网展示方式呈现平台规模与发展趋势，让可信度在清晰表达中自然建立。",
        chartBars: [
          { height: 88, color: "#C6A96B" },
          { height: 132, color: "#E6D7B5" },
          { height: 146, color: "#C6A96B" },
          { height: 210, color: "#DCE5EF" },
          { height: 194, color: "#E6D7B5" },
          { height: 261, color: "#C6A96B" },
        ],
      },
    };
  },
  methods: {
    handleNavigate(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.home {
  @include theme-variable(bg-page);
}
</style>
